import { computed, ref } from 'vue'
import { useClientActionStore } from '@/store/clientActionStore'
import { useRoute } from 'vue-router'

/**
 * This composable is used to get the theme color of the organisation, first by getting the theme color of the submission and then the organisation.
 * if the theme color is not available then it will return the default color (violet).
 * It can be used to set the color by setting the class name, for example `bg-${themeColor.value}-500`.
 * @returns themeColor - The theme color of the organisation as a ref.
 */
export function useThemeColor() {
  const themeColor = ref<string>('violet')
  const clientActionsStore = useClientActionStore()
  const org = computed(() => clientActionsStore.getOrganisation)
  const submission = clientActionsStore.getClientSubmissions.find(
    (submission) => submission.shortId === clientActionsStore.getCurrentSubmissionId
  )

  // Handle preview mode
  if (!clientActionsStore.clientAccessToken) {
    const previewSubmission =
      clientActionsStore.getClientSubmissions.length === 1
        ? clientActionsStore.getClientSubmissions[0]
        : null
    if (previewSubmission) {
      themeColor.value = previewSubmission.themeColor || 'violet'
    }
    return themeColor
  }

  // If the submission has a theme color, set the theme color to the submission's theme color, otherwise set it to the organisation's theme color
  if (submission && submission.themeColor) {
    themeColor.value = submission.themeColor
  } else if (org.value && org.value.theme) {
    themeColor.value = org.value.theme
  }

  return themeColor
}
